module.exports = __webpack_public_path__ + "assets/wpforms.de19deee.svg";